import { LitElement } from "lit-element";
import { html, render } from "lit-html";
import "@vaadin/vaadin-icons/vaadin-icons.js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import PubSub from "pubsub-js";
import "./ipc-3d-table";
import "./ipc-3d-viewer";

class Ipc3dTopic extends LitElement {
  constructor() {
    super();
    this.ipc = {};
  }

  parseHtml(htmlString) {
    const xmlString = htmlString;
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlString, "text/xml");
    this.ipc.doc = doc;
    this.ipc.imgProperties = {};

    var lblId = this.ipc.doc.querySelector(".Parts3DImage").getAttribute("src")
    this.ipc.imgProperties.imgSrc = "/kb/jrest/getResource?lblId=" + lblId

    this.ipc.table = this.ipc.doc.querySelector(".PartsTable");
    return this.ipc;
  }

  connectedCallback() {
    console.log('connectedCB', this.htmlBody)
    this.parseHtml(this.htmlBody)
    this.myRender()

    // grab the viewer and start it after the outermost wrapper is loaded
    // using setTimeout ensures that it loads at full res
    // due to the component needing to be appended to the DOM before starting
    // the viewer
    // PubSub enables/disables scrolling for usability
    const viewer = this.shadowRoot.getElementById("ipc-3d-viewer");
    viewer.addEventListener('mouseenter', (e) => {
      console.log('enter', e)
      PubSub.publish('3dViewerMouseEnter');
    })
    viewer.addEventListener('mouseleave', (e) => {
      console.log('leave', e)
      PubSub.publish('3dViewerMouseLeave')
    })
    setTimeout(() => viewer.startViewer(), 500)
  }

  refreshData() {}

  myRender() {
    render(
      html`
        <!-- <h1>KB IPC 3D Topic</h1> -->
        <vaadin-split-layout orientation="vertical" id="helpsetcontainer">
          <ipc-3d-viewer
            id="ipc-3d-viewer"
            .hostRelativeUri="${this.ipc.imgProperties.imgSrc}"
          ></ipc-3d-viewer>
          <!--<div>Lower Section</div>-->
          <ipc-3d-table .ipcTable="${this.ipc.table}"></ipc-3d-table>
        </vaadin-split-layout>
      `,
      this.shadowRoot
    );
  }
}

customElements.define("ipc-3d-topic", Ipc3dTopic);
